module.exports = __webpack_public_path__ + "static/media/i-am-that-i-am.111f03d0.txt";